// Account-manager identity for the booking step. The backend owns routing,
// the display name, and the meeting URL; the frontend maps the returned AM key
// to its headshot asset in the view layer (see book-call/view/amHeadshots.ts).
//
// `team` (GRW-330) is a non-person key for the top tier: it carries a HubSpot
// round-robin link (Klabera + Chelsea) and renders with neutral framing and no
// headshot. `klabera` stays recognized so historical frozen verdicts still
// resolve. An unrecognized key is nulled upstream, which keeps the booking
// screen from rendering a wrong identity.

export type AmKey = 'brooke' | 'klabera' | 'team';

export const isAmKey = (value: string | null | undefined): value is AmKey =>
  value === 'brooke' || value === 'klabera' || value === 'team';
